// ============================================
// HERO SLIDER
// Fullscreen slider z fade transitions,
// auto-advance, i animowanym contentem
// ============================================

(function () {
    'use strict';

    function initHeroSlider() {
        var slider = document.querySelector('.hero-slider');
        if (!slider) return;

        var slides = slider.querySelectorAll('.hero-slider__slide');
        var pagerItems = slider.querySelectorAll('.hero-slider__pager-item');
        var currentIndex = 0;
        var totalSlides = slides.length;
        var autoAdvanceInterval = null;
        var autoAdvanceDelay = 7000; // 7s per slide
        var contentAnimationDelay = 300; // ms after slide fade before content animates

        /**
         * Go to a specific slide
         */
        function goToSlide(index) {
            if (index < 0 || index >= totalSlides) return;

            // Remove active/animated from current slide
            slides[currentIndex].classList.remove('is-active');
            slides[currentIndex].classList.remove('is-animated');

            // Pause video on old slide
            var oldVideo = slides[currentIndex].querySelector('.hero-slider__bg-video');
            if (oldVideo) {
                oldVideo.pause();
            }

            currentIndex = index;

            // Activate new slide
            slides[currentIndex].classList.add('is-active');

            // Play video on new slide
            var newVideo = slides[currentIndex].querySelector('.hero-slider__bg-video');
            if (newVideo) {
                newVideo.currentTime = 0;
                newVideo.play().catch(function () { /* autoplay blocked */ });
            }

            // Update pager
            pagerItems.forEach(function (item, i) {
                item.classList.toggle('is-active', i === currentIndex);
            });

            // Trigger content animation after fade completes
            setTimeout(function () {
                slides[currentIndex].classList.add('is-animated');
            }, contentAnimationDelay);
        }

        /**
         * Advance to next slide (wraps around)
         */
        function nextSlide() {
            var next = (currentIndex + 1) % totalSlides;
            goToSlide(next);
        }

        /**
         * Start auto-advance timer
         */
        function startAutoAdvance() {
            stopAutoAdvance();
            autoAdvanceInterval = setInterval(nextSlide, autoAdvanceDelay);
        }

        /**
         * Stop auto-advance timer
         */
        function stopAutoAdvance() {
            if (autoAdvanceInterval) {
                clearInterval(autoAdvanceInterval);
                autoAdvanceInterval = null;
            }
        }

        // ---- Pager click (po indeksie — pozwala warunkowo dodać slajd bez przenumerowania data-slide) ----
        pagerItems.forEach(function (item, i) {
            item.addEventListener('click', function () {
                goToSlide(i);
                startAutoAdvance(); // Reset timer on manual navigation
            });
        });

        // ---- Touch/swipe support ----
        var touchStartX = 0;
        var touchEndX = 0;
        var isSwiping = false;

        slider.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].screenX;
            isSwiping = true;
        }, { passive: true });

        slider.addEventListener('touchend', function (e) {
            if (!isSwiping) return;
            touchEndX = e.changedTouches[0].screenX;
            var diff = touchStartX - touchEndX;

            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    // Swipe left → next
                    goToSlide((currentIndex + 1) % totalSlides);
                } else {
                    // Swipe right → prev
                    goToSlide((currentIndex - 1 + totalSlides) % totalSlides);
                }
                startAutoAdvance();
            }
            isSwiping = false;
        }, { passive: true });

        // ---- Pause on hover (desktop) ----
        if (totalSlides > 1) {
            slider.addEventListener('mouseenter', stopAutoAdvance);
            slider.addEventListener('mouseleave', startAutoAdvance);
        }

        // ---- Initialize first slide ----
        slides.forEach(function (slide, i) {
            if (i !== 0) slide.classList.remove('is-active', 'is-animated');
        });
        pagerItems.forEach(function (item, i) {
            item.classList.toggle('is-active', i === 0);
        });
        slides[0].classList.add('is-active');
        setTimeout(function () {
            slides[0].classList.add('is-animated');
        }, contentAnimationDelay);

        // Start auto-advance
        if (totalSlides > 1) {
            startAutoAdvance();
        }
    }

    document.addEventListener('DOMContentLoaded', initHeroSlider);
})();
